import {Link} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {NavLink} from 'react-router';

const NavItem = ({children, ...props}) => (
  <Link
    component={NavLink}
    end
    sx={theme => ({
      color: 'inherit',
      '&:hover': {
        color: (theme.vars || theme).palette.primary.main,
      },
      '&.active': {
        color: (theme.vars || theme).palette.primary.main,
        '&:hover': {
          color: 'inherit',
        },
      },
    })}
    underline="none"
    variant="body2"
    {...props}
  >
    {children}
  </Link>
);

NavItem.propTypes = {
  children: PropTypes.node,
};

export default NavItem;
